/**
 * Load font Inter qua CDN MISA, URL lấy trực tiếp từ VITE_FONT_CDN_SITE (khai báo riêng theo từng file .env).
 * Font local trong assets/css/fonts.css (import trước dòng này trong main.js)
 * đóng vai trò dự phòng nếu CDN không truy cập được.
 */
const href = import.meta.env.VITE_FONT_CDN_SITE;

if (href) {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = href;
  link.onerror = () => {
    console.warn(`[Font] Không tải được font Inter từ CDN (${href}). Dùng font local dự phòng.`);
  };
  document.head.appendChild(link);
}
